<ng-container *ngIf="loginFormType" [ngSwitch]="loginFormType">
	<ng-container *ngSwitchCase="'Dga'">
		<obg-m-dga-login-component
			[autoFocus]="false"
			[errorsInAlert]="errorsInAlert"
			[allLinksExternal]="allLinksExternal"
			[hideEmailPasswordLogin]="hideEmailPasswordLoginForDga"
			(busy)="busy.emit($event)"
		>
		</obg-m-dga-login-component>
	</ng-container>
	<ng-container *ngSwitchCase="'Sga'">
		<mat-tab-group
			[disablePagination]="true"
			[attr.mat-stretch-tabs]="stretchedTabs || null"
			[dynamicHeight]="false"
			[@.disabled]="true"
			[selectedIndex]="selectedTab"
			(selectedIndexChange)="selectedTabClick($event)"
		>
			<mat-tab>
				<ng-template mat-tab-label>
					<span
						[innerHTML]="'login.type.email-password' | translate"
						data-test-id="email-password-login-tab"
					></span>
				</ng-template>
				<ng-template matTabContent>
					<ng-container [ngTemplateOutlet]="generic"></ng-container>
				</ng-template>
			</mat-tab>
			<mat-tab>
				<ng-template mat-tab-label>
					<span data-test-id="bank-id-login-tab">{{ "login.type.bank-id" | translate }}</span>
				</ng-template>
				<ng-template matTabContent>
					<obg-m-sga-login-container [showLoginTitle]="showSgaLoginTitle" (busy)="busy.emit($event)">
					</obg-m-sga-login-container>
				</ng-template>
			</mat-tab>
		</mat-tab-group>
	</ng-container>
	<ng-container *ngSwitchCase="'SmartId'">
		<mat-tab-group
			[disablePagination]="true"
			[attr.mat-stretch-tabs]="stretchedTabs || null"
			[dynamicHeight]="false"
			[@.disabled]="true"
			[selectedIndex]="selectedTab"
			(selectedIndexChange)="selectedTabClick($event)"
			test-id="smart-id-tab"
		>
			<mat-tab [disabled]="disableTab">
				<ng-template mat-tab-label>
					<span [innerHTML]="'login.type.email-password' | translate"></span>
				</ng-template>
				<ng-template matTabContent>
					<ng-container [ngTemplateOutlet]="generic"></ng-container>
				</ng-template>
			</mat-tab>
			<mat-tab [disabled]="disableTab">
				<ng-template mat-tab-label>
					<span class="ico-smart-id" data-test-id="smart-id-tab"></span>
				</ng-template>
				<ng-template matTabContent>
					<ng-container *ngTemplateOutlet="showIauiSelfExclusion"></ng-container>
					<obg-m-smart-id-login-form-container
						(disableTab)="disableTab= $event"
						data-test-id="smart-id-login-form"
					></obg-m-smart-id-login-form-container>
				</ng-template>
			</mat-tab>
		</mat-tab-group>
	</ng-container>
	<ng-container *ngSwitchDefault>
		<ng-container [ngTemplateOutlet]="generic"></ng-container>
	</ng-container>
</ng-container>

<ng-template #generic>
	<div *ngIf="showGenericLoginTitle && !showSgaView" class="generic-login-title">
		{{ 'general.sign-in' | translate }}
	</div>
	<ng-container *ngTemplateOutlet="showIauiSelfExclusion"></ng-container>
	<obg-m-generic-login-container
		[disallowedRedirection]="disallowedRedirection"
		[disallowLogin]="disallowLogin"
		[autoFocus]="autoFocus"
		[errorsInAlert]="errorsInAlert"
		[allLinksExternal]="allLinksExternal"
		(forgotPasswordClick)="forgotPasswordButtonClick.emit()"
		(busy)="busy.emit($event)"
	>
	</obg-m-generic-login-container>
</ng-template>
<div *ngIf="shouldShowRegisterButton && selectedTab !== bankIdTab" class="obg-m-login-extra-action">
	<span>{{ 'login.dont-have-account' | translate }}&nbsp;</span>
	<a
		[obgRouteLink]="registerRouteLink"
		[obgInteraction]="createAccountTrackingData"
		[target]="allLinksExternal ? '_blank' : null"
		(click)="registerButtonClick.emit()"
		test-id="login-create-account"
		>{{ 'login.create-account' | translate }}</a
	>
</div>

<ng-template #showIauiSelfExclusion>
	<div *ngIf="showIauiSelfExclusionText" class="obg-m-login-iaui-self-exclusion">
		<span class="obg-m-login-iaui-self-exclusion-text">
			<span class="ico-information-circle"></span>
			<span [innerHtml]="'iaui.self-exclusion.disclaimer' | translate"></span>
		</span>
	</div>
</ng-template>
